import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";
import { useTheme } from "../../../../context/ThemeContext";
import heroVideo from "../../../../assets/hero.mp4";

const Hero = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: false, amount: 0.5 });
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { isDarkTheme } = useTheme();

  const handleGetStartedClick = () => {
    if (isAuthenticated) {
      navigate("/chat");
    } else {
      navigate("/auth");
    }
  };

  return (
    <motion.section
      id="hero"
      ref={sectionRef}
      className="w-full h-screen relative px-4 flex justify-center items-center mt-[-1.9rem]"
      initial={{ opacity: 1, y: 30 }}
      transition={{ duration: 0.3, ease: "linear" }}
    >
      {/* Background Video with overlay */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[-1] ${
          isDarkTheme 
            ? 'bg-black opacity-60' 
            : 'bg-black opacity-30'
        }`} 
      />
      <video
        src={heroVideo}
        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover z-[-10]"
      />

      <div className="container mx-auto w-full flex flex-col justify-center items-center gap-10 px-6 text-center mt-16">
        {/* Text Section */}
        <motion.div
          className="flex flex-col justify-center items-center gap-6 md:mx-auto]"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
          transition={{ duration: 0.3, ease: "linear" }}
        >
          {/* Main Heading */}
          <h1 
            className={`text-4xl sm:text-5xl lg:text-6xl font-bold leading-snug mb-5  ${
              isDarkTheme 
                ? 'text-white' 
                : 'text-white'
            }`}
          >
            Revolutionizing{" "}
            <span
              className="bg-gradient-to-r from-amber-300 to-amber-600 bg-clip-text text-transparent inline drop-shadow-[0_0_8px_rgba(0,0,0,1.8)]"
            >
              Petroleum 
            </span>{" "}
            <br />
            Industry with AI
          </h1>

          {/* Subheading */}
          <p 
            className={`text-lg sm:text-xl xl:text-2xl mb-6  ${
              isDarkTheme 
                ? 'text-white/70 drop-shadow-[0_0_8px_rgba(0,0,0,0.7)] font-normal' 
                : 'text-white drop-shadow-[0_0_8px_rgba(0,0,0,0.4)] font-normal'
            }`}
          >
            Unlock the potential of Drilling, Reservoir, and Petroleum Production 
            <br />
            Optimization with AI-powered Chatbots
          </p>

          {/* Button */}
          <button
            onClick={handleGetStartedClick}
            className="px-8 py-3 text-lg bg-gradient-to-r from-amber-400 to-amber-700 text-white rounded-full font-semibold transition-all duration-300 hover:from-amber-500 hover:to-amber-700 focus:outline-none"
          >
            Ask, Learn, Drill
          </button>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Hero;